$(document).ready(function () {
    var rangeSlider = document.getElementById('priceSlider');
    if (!rangeSlider || typeof noUiSlider === 'undefined' || rangeSlider.noUiSlider) return; // CHQ 2026-10-11: no price slider on this page (hub collections) -> was throwing 'reading nodeName'

    var filterMinValue = parseInt($(".customPriceRangeSliderContainer").attr("data-minValue"));

    var currentMaxValue = parseInt($(".customPriceRangeSliderContainer").attr("data-currentMaxValue"));

    var filterMaxValue = parseInt($(".customPriceRangeSliderContainer").attr("data-maxValue"));


    var moneyFormat = wNumb({
        decimals: 0,
        thousand: ',',
        prefix: '$'
    });

    noUiSlider.create(rangeSlider, {
        start: [filterMinValue, currentMaxValue],
        step: 1,
        range: {
            'min': [0],
            'max': [filterMaxValue]
        },
        format: moneyFormat,
        connect: true
    });

    rangeSlider.noUiSlider.on('update', function (values, handle) {
        document.getElementById('slider-value-min').innerHTML = values[0];
        document.getElementById('slider-value-max').innerHTML = values[1];

        var minValueWithoutDollar = values[0].replace('$', '');
        var maxValueWithoutDollar = values[1].replace('$', '');
      
        $(".filterMinValueInput").val(minValueWithoutDollar);
        $(".filterMaxValueInput").val(maxValueWithoutDollar);
    });
});